import { PromptPopup } from '../popupTemplates/promptPopup/prompt.popup.tsx';

// Module-level singleton used by the navigation blocker and rendered once inside <AppSidebar/>.
// Kept in its own file so the blocker can import it without pulling the sidebar React tree.
export const promptPopup = new PromptPopup({ showCancelButton: false });
